module.exports = __webpack_public_path__ + "img/brands-wasa-forest.jpg?38eb9b269622feaabac58cb6945e2fb7";